import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const ActivityIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 20 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M6.16872 0.939106C6.6342 -0.372604 8.38825 -0.243038 8.83481 0.910945L8.84521 0.93863L8.84524 0.938703L12.5556 11.1423L13.6945 8.29515L13.7078 8.26282C13.9928 7.58773 14.655 7.14716 15.3902 7.14715H18.75C19.4404 7.14716 20 7.70679 20 8.39714C20 9.08749 19.4404 9.64713 18.75 9.64713H15.8463L13.8169 14.7208C13.3364 15.922 11.6246 15.8976 11.1815 14.6789V14.6789L11.169 14.6446V14.6446L7.55131 4.69596L6.28451 8.49642C6.05552 9.18341 5.41257 9.64713 4.68805 9.64713H1.24999C0.559633 9.64713 1.23699e-06 9.0875 0 8.39714C0 7.70679 0.559632 7.14715 1.24999 7.14715H4.099L6.15788 0.9706L6.16872 0.939106Z'
        fill={color}
      />
    </svg>
  )
})

ActivityIcon.displayName = 'ActivityIcon'
